import type { QuestionType } from "../../lib/types";

type Props = {
  value: QuestionType;
  onChange: (next: QuestionType) => void;
  /** When true, the picker is read-only (e.g., the question already has responses). */
  locked?: boolean;
  lockReason?: string;
};

const TYPES: Array<{ value: QuestionType; label: string; hint: string }> = [
  { value: "open_text", label: "Offener Text", hint: "Freitext, KI clustert Themen." },
  { value: "nps", label: "NPS", hint: "0–10 Skala mit Begründung." },
  { value: "multiple_choice", label: "Multiple Choice", hint: "Vorgegebene Optionen + Sonstiges." },
  { value: "polar", label: "Polar (A vs B)", hint: "Zwei klare Alternativen + Warum." },
  { value: "likert", label: "Likert (1–5)", hint: "Zustimmungsskala 1–5 mit Begründung." },
];

export function QuestionTypePicker({ value, onChange, locked, lockReason }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-medium text-rc-ink">Fragetyp</div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {TYPES.map((t) => {
          const selected = t.value === value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => !locked && onChange(t.value)}
              disabled={locked && !selected}
              className={[
                "flex flex-col gap-1 rounded-xl border px-3 py-3 text-left transition",
                selected
                  ? "border-rc-berry bg-rc-berry/5 shadow-berry"
                  : "border-rc-ink/10 bg-rc-paper hover:border-rc-ink/30",
                locked && !selected ? "opacity-40" : "",
              ].join(" ")}
              aria-pressed={selected}
            >
              <span className="text-sm font-semibold text-rc-ink">{t.label}</span>
              <span className="text-xs text-rc-ink/60">{t.hint}</span>
            </button>
          );
        })}
      </div>
      {locked && lockReason && (
        <p className="text-xs text-rc-ink/60">{lockReason}</p>
      )}
    </div>
  );
}
